import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAssetOperaIconOl = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 20C0 13.4729 0 10.2094 1.1453 7.66463C2.44896 4.76803 4.76803 2.44896 7.66463 1.1453C10.2094 0 13.4729 0 20 0C26.5271 0 29.7906 0 32.3354 1.1453C35.232 2.44896 37.551 4.76803 38.8547 7.66463C40 10.2094 40 13.4729 40 20C40 26.5271 40 29.7906 38.8547 32.3354C37.551 35.232 35.232 37.551 32.3354 38.8547C29.7906 40 26.5271 40 20 40C13.4729 40 10.2094 40 7.66463 38.8547C4.76803 37.551 2.44896 35.232 1.1453 32.3354C0 29.7906 0 26.5271 0 20Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.4268 38.6601C14.3225 38.7992 16.7188 38.8 20 38.8C23.2812 38.8 25.6775 38.7992 27.5732 38.6601C29.457 38.5217 30.7518 38.2515 31.8429 37.7604C34.4721 36.5771 36.5771 34.4721 37.7604 31.8429C38.2515 30.7518 38.5217 29.457 38.6601 27.5732C38.7992 25.6775 38.8 23.2812 38.8 20C38.8 16.7188 38.7992 14.3225 38.6601 12.4268C38.5217 10.543 38.2515 9.2482 37.7604 8.15713C36.5771 5.5279 34.4721 3.4229 31.8429 2.23958C30.7518 1.74853 29.457 1.47825 27.5732 1.33994C25.6775 1.20075 23.2812 1.2 20 1.2C16.7188 1.2 14.3225 1.20075 12.4268 1.33994C10.543 1.47825 9.2482 1.74853 8.15713 2.23958C5.5279 3.4229 3.4229 5.5279 2.23958 8.15713C1.74853 9.2482 1.47825 10.543 1.33994 12.4268C1.20075 14.3225 1.2 16.7188 1.2 20C1.2 23.2812 1.20075 25.6775 1.33994 27.5732C1.47825 29.457 1.74853 30.7518 2.23958 31.8429C3.4229 34.4721 5.5279 36.5771 8.15713 37.7604C9.2482 38.2515 10.543 38.5217 12.4268 38.6601ZM1.1453 7.66463C0 10.2094 0 13.4729 0 20C0 26.5271 0 29.7906 1.1453 32.3354C2.44896 35.232 4.76803 37.551 7.66463 38.8547C10.2094 40 13.4729 40 20 40C26.5271 40 29.7906 40 32.3354 38.8547C35.232 37.551 37.551 35.232 38.8547 32.3354C40 29.7906 40 26.5271 40 20C40 13.4729 40 10.2094 38.8547 7.66463C37.551 4.76803 35.232 2.44896 32.3354 1.1453C29.7906 0 26.5271 0 20 0C13.4729 0 10.2094 0 7.66463 1.1453C4.76803 2.44896 2.44896 4.76803 1.1453 7.66463Z",
			fill: "#E7E8E8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.0006 6.00279C17.7314 6.00263 15.4961 6.5541 13.4873 7.60969C11.4786 8.66528 9.75653 10.1933 8.4695 12.0623C7.18246 13.9312 6.36904 16.085 6.09928 18.3382C5.82951 20.5913 6.1115 22.8762 6.92096 24.9962C7.73041 27.1161 9.04306 29.0076 10.7459 30.5075C12.4487 32.0075 14.4906 33.071 16.6957 33.6066C18.9008 34.1421 21.2031 34.1336 23.4042 33.5818C25.6053 33.0299 27.6393 31.9513 29.3309 30.4388C27.6714 31.5527 25.7186 32.149 23.7199 32.1521C20.3851 32.1521 17.4013 30.4973 15.3898 27.8896C13.8408 26.062 12.8406 23.3623 12.7709 20.3312V19.6681C12.8406 16.6369 13.8408 13.9345 15.3898 12.1097C17.3957 9.502 20.3851 7.84712 23.7199 7.84712C25.7704 7.84712 27.69 8.47396 29.3309 9.56329C26.7806 7.27708 23.4785 6.0088 20.0535 6H19.9978L20.0006 6.00279Z",
			fill: "url(#paint0_linear_6199_8808)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.3934 12.1133C16.675 10.5977 18.3382 9.68113 20.1491 9.68113C24.225 9.68113 27.532 14.3059 27.532 20.0005C27.532 25.7006 24.2278 30.3198 20.1491 30.3198C18.3382 30.3198 16.6778 29.406 15.3934 27.8904C17.3993 30.4981 20.3859 32.153 23.7235 32.153C25.7221 32.1488 27.6746 31.5526 29.3345 30.4396C30.805 29.128 31.981 27.5199 32.7853 25.7211C33.5896 23.9223 34.004 21.9736 34.0011 20.0032C34.0034 18.0327 33.5886 16.0839 32.7838 14.2852C31.979 12.4864 30.8025 10.8784 29.3318 9.5669C27.6722 8.45299 25.7195 7.85668 23.7208 7.85352C20.3859 7.85352 17.4021 9.5084 15.3906 12.1161",
			fill: "url(#paint1_linear_6199_8808)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_6199_8808",
			x1: 17.6604,
			y1: 6.46248,
			x2: 17.6604,
			y2: 33.5981,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .6,
				stopColor: "#FF1B2D"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#A70014"
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_6199_8808",
			x1: 24.7098,
			y1: 8.05132,
			x2: 24.7098,
			y2: 32.0666,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#9C0000" }), /* @__PURE__ */ _jsx("stop", {
				offset: .7,
				stopColor: "#FF4B4B"
			})]
		})] })
	]
});
export default SvgAssetOperaIconOl;
